export default __webpack_public_path__ + "static/media/volume-down.9336cf47.svg";